import { motion } from 'framer-motion'
import type { ReactNode } from 'react'
import { fadeUp } from '../lib/motion'

type CalmBlockProps = {
  calm?: boolean
  className?: string
  children: ReactNode
  viewportAmount?: number
}

/** Kontener sekcji: albo statyczny `div`, albo `motion.div` z wejściem przy scrollu. */
export function CalmBlock({
  calm,
  className,
  children,
  viewportAmount = 0.2,
}: CalmBlockProps) {
  if (calm) return <div className={className}>{children}</div>
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: viewportAmount }}
      variants={{ visible: { transition: { staggerChildren: 0.06 } } }}
      className={className}
    >
      {children}
    </motion.div>
  )
}

export function CalmItem({
  calm,
  className,
  children,
}: {
  calm?: boolean
  className?: string
  children: ReactNode
}) {
  if (calm) return <div className={className}>{children}</div>
  return (
    <motion.div variants={fadeUp} className={className}>
      {children}
    </motion.div>
  )
}

export function CalmLi({
  calm,
  className,
  children,
}: {
  calm?: boolean
  className?: string
  children: ReactNode
}) {
  if (calm) return <li className={className}>{children}</li>
  return (
    <motion.li variants={fadeUp} className={className}>
      {children}
    </motion.li>
  )
}

export function CalmDetails({
  calm,
  className,
  children,
}: {
  calm?: boolean
  className?: string
  children: ReactNode
}) {
  if (calm) return <details className={className}>{children}</details>
  return (
    <motion.details variants={fadeUp} className={className}>
      {children}
    </motion.details>
  )
}
